import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element";
import "./plugins/axios";
import "./assets/css/common.scss";
import AuthButton from "@/components/auth-button";
import AuditStateText from "@/views/components/audit-state-text";
import { VueJsonp } from "vue-jsonp";
import "./assets/iconfont/iconfont.css";
import "./assets/css/element-variables.scss";
import { getProxy } from "./plugins/axios";

Vue.use(VueJsonp);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.path == "/" || to.path == "/login") {
    next();
    return;
  }
  store.commit("setBreadcrumb", {
    path: to.path,
    ...to.meta, // title funcKey isInfo
  });
  next();
});

Vue.component("auth-button", AuthButton);
Vue.component("audit-state-text", AuditStateText);

Vue.directive("auth", {
  inserted: (el, binding, vnode) => {
    if (!store.state.myFuncKey.find((e) => e === binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});
getProxy().then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
